import { useAppContext } from "./useAppContext";

/**
 * Get a feature flag as string
 * @public
 */
export const useFeatureFlag: ReturnType<
	typeof useAppContext
>["featureManager"]["getFeatureFlagAsString"] = (flagName, defaultValue) => {
	const { featureManager } = useAppContext();

	return featureManager.getFeatureFlagAsString(flagName, defaultValue);
};

/** Get a feature flag as boolean (value must be "true") */
export const useFeatureFlagToggle: ReturnType<
	typeof useAppContext
>["featureManager"]["getFeatureFlagAsBoolean"] = (flagName) => {
	const { featureManager } = useAppContext();

	return featureManager.getFeatureFlagAsBoolean(flagName);
};
